import { LocationDto } from '@app/hooks';

import { MappedFacetValue, UnmappedFacetValue } from '../constants';

export const getLocationLabel = ({
  id,
  locations = [],
  labelFallback = '',
}: {
  id: string;
  locations?: LocationDto[];
  labelFallback?: string;
}) => {
  const locationLabel = locations.find(location => location.id === id);

  return (
    locationLabel?.discoveryDisplayName ?? locationLabel?.name ?? labelFallback
  );
};

export const getLocationOptions = (
  locations: LocationDto[] = [],
  values: UnmappedFacetValue[] = [],
  labelFallback = ''
): MappedFacetValue[] =>
  values.map(({ id, totalRecords }) => {
    return {
      label: getLocationLabel({ id, locations, labelFallback }),
      value: id,
      count: totalRecords,
      id,
    };
  });
